<template>
  <div :content="broker" v-tippy="{ arrow: true, theme: 'green' }" class="h-5 w-5 flex items-center justify-center">
    <i v-html="styles" class="h-5 w-5 flex"></i>
  </div>
</template>

<script>
export default {
  props: {
    broker: {
      type: String,
    },
  },
  computed: {
    styles() {
      switch (this.broker) {
        case "OnTick":
          return this.$icons.xs_logo;

        case "XP":
          return this.$icons.xs_xp_logo;

        case "RICO":
          return this.$icons.rico_badge;

        case "CLEAR":
          return this.$icons.clear;

        default:
          return this.$icons.trophy;
      }
    },
  },
};
</script>

<style></style>
